module.exports = "#logo {\n    height: 120px;\n}\n.clickable {\n    cursor: pointer;\n}\n"